import React from "react";
import { getColor } from "../../../../utils/getColor";
import { Wrapper, Badge, BadgeContainer } from "./style";

export default ({ value, userRank, userRateType, column = false }) => {
  return (
    <>
      {userRank || userRank === 0 ? (
        <Wrapper column={column}>
          <BadgeContainer>
            <span
              style={{
                fontStyle: "italic",
                fontSize: "12px",
              }}
            >
              Рейтинг:
            </span>
            <Badge value={getColor(userRank)}>{userRateType}</Badge>
          </BadgeContainer>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            {value}
          </span>
        </Wrapper>
      ) : (
        <span
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            minWidth: "30px",
            textAlign: "center",
          }}
        >
          {value}
        </span>
      )}
    </>
  );
};
